var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSouthafrica(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 20.4853C-1.17157 15.799 -1.17157 8.20104 3.51471 3.51471C3.51438 3.51523 10.4348 12 10.4348 12L3.51471 20.4853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4351 12L1.59187 6.02405C1.3177 6.50063 1.07591 6.99806 0.868164 7.51294L5.34515 12L0.868305 16.4874C1.07587 17.0019 1.31741 17.499 1.5914 17.9753L10.4351 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8982 10.4348H10.4342L3.51434 3.51489C2.76865 4.26058 2.12079 5.10391 1.59129 6.02411L7.55562 12L1.59082 17.9752C2.12032 18.8956 2.76846 19.7392 3.51434 20.4851L10.4342 13.5652H23.8982C23.9649 13.0529 23.9997 12.5305 23.9997 12C23.9997 11.4695 23.9649 10.9472 23.8982 10.4348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69434 21.5192C6.71788 23.0746 9.25087 24 12.0004 24C17.5447 24 22.21 20.2396 23.587 15.1304H11.0832L4.69434 21.5192Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.587 8.86955C22.21 3.76036 17.5447 0 12.0004 0C9.25087 0 6.71788 0.925359 4.69434 2.48077L11.0831 8.86955H23.587Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/a9e1f538.svg";
export { SvgSouthafrica as ReactComponent };